export enum PrintLabelEntityTypes {
  Structure = 'structure',
  PartType = 'partType',
  Shipment = 'shipment',
  Part = 'part',
  FreightOrderLabel = 'freightOrderLabel'
}